import { useField } from 'formik';
import { Flex, Box, Text } from '@chakra-ui/react';
import { useIntl, FormattedMessage } from 'react-intl';

import CheckboxField from '../forms/CheckboxField';
import ComboboxField from '../forms/ComboboxField';

const HedgeCommonPropertySelect = ({
    name,
    label,
    isDisabled,
    options,
    placeholder = '-',
    onMultipleToggleChange,
    onChange,
    validate,
    info,
    footerLabel,
    ...rest
}) => {
    const intl = useIntl();
    const [{ value }, _, { setValue }] = useField({ name, validate }); // eslint-disable-line

    const isMultipleSupported = Array.isArray(value);
    const isMultipleSelected = isMultipleSupported && value.includes('multiple');
    let selected = '-';
    const MULTIPLE_PLACEHOLDER_VALUE = 'multiple';

    if (isMultipleSupported) {
        if (isMultipleSelected) {
            // if there is only a single real id in the value array then show it as selected
            // otherwise we have multiple instruments that have different values and we should show 'multiple'
            selected = value.length > 2 ? MULTIPLE_PLACEHOLDER_VALUE : value[0];
        } else if (value.length === 1) {
            selected = value[0];
        } else {
            selected = -1;
        }
    } else {
        selected = value;
    }

    return (
        <Flex direction="column" {...rest}>
            <ComboboxField
                id={name}
                name={name}
                info={info}
                label={label}
                isDisabled={isDisabled || isMultipleSelected}
                value={selected}
                options={options}
                valueKey="id"
                labelKey="description"
                onChange={(v) => {
                    const newValue = isMultipleSupported ? [v] : v;
                    setValue(newValue);
                    onChange(v);
                }}
                showPlaceholder={!!placeholder || isMultipleSelected}
                placeholderValue={isMultipleSelected ? MULTIPLE_PLACEHOLDER_VALUE : -1}
                placeholderLabel={
                    isMultipleSelected ? intl.formatMessage({ id: 'hedge_select_multiple' }) : placeholder
                }
            />

            {isMultipleSupported && (
                <CheckboxField
                    mt={2}
                    id={`multiple_select_${name}`}
                    name={`multiple_select_${name}`}
                    isDisabled={isDisabled}
                    isChecked={isMultipleSelected}
                    onChange={onMultipleToggleChange}
                >
                    <Text as="span" fontSize="12px" color="gray.600">
                        <FormattedMessage id="hedge_select_multiple" />
                    </Text>
                </CheckboxField>
            )}

            {footerLabel && (
                <Box fontSize={12} mt={2}>
                    {footerLabel}
                </Box>
            )}
        </Flex>
    );
};

export default HedgeCommonPropertySelect;
